module.exports = __webpack_public_path__ + "static/media/riflessioni.9016f27d.jpeg";